import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import TwoOptionsRow from "components/TwoOptionsRow";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { addToIgnoreList } from "slices/discovery/actions/actionButtons";

const IgnoreTermConfirm = ({ terms, term }) => {
  const dispatch = useDispatch();
  const [ignoreHoveredOnly, setIgnoreHoveredOnly] = useState(false);

  const handleIgnore = () => {
    dispatch(addToIgnoreList(ignoreHoveredOnly ? [term] : terms));
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IGNORE_TERM_CONFIRM));
  };

  const getTermsList = () => {
    if (terms.length === 2) {
      return `"${terms[0]}" and "${terms[1]}"`;
    }
    return `"${terms[0]}", "${terms[1]}" and ${terms.length - 2} ${terms.length === 3 ? "other" : "others"}`;
  };

  return (
    <Modal
      show
      className="fade-in discovery_ignore_terms_confirm"
      backdrop
      onDismiss={handleCancel}
      centered
    >
      <Modal.Header>
        <b>Confirm Ignore Action</b>
      </Modal.Header>
      <Modal.Body>
        <p>
          You have checked {terms.length} items: {getTermsList()}.
        </p>
        <TwoOptionsRow
          option1={`Ignore all ${terms.length} items`}
          option2={`Just ignore "${term}"`}
          state={ignoreHoveredOnly}
          setState={setIgnoreHoveredOnly}
        />
      </Modal.Body>
      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={handleCancel}>
          Cancel
        </NewButton>

        <NewButton variant={NewButtonVariant.l1} onClick={handleIgnore}>
          Ignore
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default IgnoreTermConfirm;

IgnoreTermConfirm.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.string),
  term: PropTypes.string,
};
